import Button from "./button";
import { useNavigate } from "react-router-dom";

const InvitationSentCard = ({ img, text, showCard, linkTo }) => {
  const navigate = useNavigate();
  const ClickHandler = () => {
    if (showCard) {
      showCard();
    }
    linkTo ? navigate(linkTo) : navigate("/main/profile/manage-team");
  };
  return (
    <div className="w-full h-12.4 border-solid rounded-lg border-inputFieldGrey flex items-center">
      <div className="flex sm:flex-row flex-col items-center space-y-2 sm:space-y-0 justify-between w-full ">
        <div className="flex items-center font-medium">
          <img src={img} alt="as" className="ml-3 mr-1" />
          <span>{text}</span>
        </div>
        <Button
          title="Done"
          className="flex items-center w-15.8 h-3.8 bg-primaryBlue sm:mr-3"
          onClick={ClickHandler}
        />
      </div>
    </div>
  );
};
export default InvitationSentCard;
